export default __webpack_public_path__ + "static/media/avatars-naranjo-5.029c3fd6.svg";